import {BackgroundView} from '@fantasmagames/slot/src/modules/background/BackgroundView';
import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {BackgroundBasicState} from '@fantasmagames/slot/src/modules/background/states/BackgroundBasicState';
import {BackgroundDebuggingComponent} from '@fantasmagames/slot/src/modules/background/debuggingComponent/BackgroundDebuggingComponent';

export class BackgroundModule extends Module<BackgroundView> {
	public static readonly BASIC_STATE: string = 'basic';

	public static readonly BACKGROUND_CREATED_EVENT: string = 'BackgroundModule::BACKGROUND_CREATED_EVENT';

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.BACKGROUND_VIEW_MOBILE);
		} else {
			this.setView(Views.BACKGROUND_VIEW);
		}
	}

	public addDebuggingComponent(): void {
		new BackgroundDebuggingComponent(this, this.view);
	}

	protected setupStates(): void {
		super.setupEvents();

		this.addState(new BackgroundBasicState(this, BackgroundModule.BASIC_STATE));
	}

	protected enterFirstState(): void {
		this.changeStateTo(BackgroundModule.BASIC_STATE);
	}

	protected setupEvents(): void {
		this.onViewCurrentStateHandle(BackgroundView.VIEW_TRANSITION_TO_MAINGAME_COMPLETED);
		this.onViewCurrentStateHandle(BackgroundView.VIEW_TRANSITION_TO_FREESPINS_COMPLETED);

		this.onViewEmitEvent(BackgroundView.BACKGROUND_CREATED, BackgroundModule.BACKGROUND_CREATED_EVENT);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/background/BackgroundModule.ts